import { config } from "./baseUrl";
import { getEnvArea } from "./utils";

const proxyBaseUrl = `http:${config[getEnvArea()]}`;

/**
 * 代理配置
 */
const proxy = {
  "/api/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/mtsV2/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/stub/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/system/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/auth/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/employee/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
  "/loginLog/": {
    target: proxyBaseUrl,
    changeOrigin: true,
  },
};

export default proxy;
